import { Table } from "antd"
import { buildLineItemViewData, LineItemViewData } from "./lineItemsModel"
import { InvoiceDetail, InvoiceSummary } from "../../../domain/invoicing/invoice"
import LineItemDescription from "./LineItemDescription"
import BalanceDisplay from "./BalanceDisplay"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { ColumnType } from "antd/es/table"

type Props = {
  detail: InvoiceDetail
  invoiceSummary: InvoiceSummary
  view: 'basic' | 'compare'
}

const LineItemsTable = ({ detail, invoiceSummary, view }: Props) => {
  const lines = buildLineItemViewData(detail, invoiceSummary.balance, invoiceSummary)

  const columns: ColumnType<LineItemViewData>[] = [
    {
      title: 'SynkedUP',
      render: (_, x) => <LineItemDescription description={x.description} descriptionHtml={x.descriptionHtml} />
    },
    {
      title: '',
      align: 'right',
      render: (_, x) => {
        if (x.key === 'balance') {
          return <>
            {x.amountLabel}
            <BalanceDisplay
              balance={x.amount!}
              isFullyPaid={x.amount === 0}
              hasPaymentProblem={invoiceSummary.hasPaymentProblem}
              hasPendingPayment={invoiceSummary.hasPendingPayment}
            />
          </>
        }
        return `${x.amountLabel}${centsToDollarsDisplay(x.amount) ?? ''}`
      },
      onCell: (x) => ({style: {fontWeight: fontWeightByKey[x.key] ?? 'normal'}})
    },
  ]

  if (view === 'compare') {
    columns.push({
      title: 'QuickBooks',
      render: (_, x) => <LineItemDescription description={x.qboDescription} descriptionHtml={null} />,
      onHeaderCell: () => ({style: {borderLeft: '2px solid black'}}),
      onCell: (_) => ({style: {borderLeft: '2px solid black'}})
    })
    columns.push({
      title: '',
      align: 'right',
      render: (_, x) => {
        if (x.key === 'balance') {
          return <>
            {x.amountLabel}
            <BalanceDisplay
              balance={x.amount!}
              isFullyPaid={x.amount === 0}
              hasPaymentProblem={invoiceSummary.hasPaymentProblem}
              hasPendingPayment={invoiceSummary.hasPendingPayment}
            />
          </>
        }
        if (x.qboAmount === null) {
          return ''
        }
        return `${x.amountLabel}${centsToDollarsDisplay(x.qboAmount)}`
      },
      onCell: (x) => ({style: {fontWeight: fontWeightByKey[x.key] ?? 'normal'}})
    })
  }

  return <Table
    rowKey={x => x.key}
    dataSource={lines}
    showHeader={view === 'compare'}
    columns={columns}
    pagination={false}
  />
}

export default LineItemsTable

const fontWeightByKey: Record<string, string> = {
  'total': 'bold',
  'balance': 'bold'
}
